<ng-container *ngIf="worker">
  <ng-container *transloco="let t">
    <c-container>
      <c-row>
        <c-col>
          <h5>{{ t('Manage Your ZOLEO Device') }}</h5>
          <br/>
          {{ t('ZOLEO Devices can be linked to OK Alone. This means you can update your status and location using your ZOLEO device.') }}
          <br/>
          {{ t('Note: This is a new feature. Please email us at customer.support@ok-alone.com if you want to use your ZOLEO Device') }}
          <br/>
          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-list"></i> {{ t('Saved ZOLEO Device:') }}</label>
              <div class="col-8">
                <ng-select
                  [items]="zoleoDeviceOptions"
                  bindLabel="display"
                  bindValue="id"
                  [searchable]="true"
                  [clearable]="false"
                  [ngModel]="selectedDeviceId"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onDeviceSelect($event)"
                ></ng-select>
                <small class="text-muted d-block mt-1" *ngIf="loadingDevices">{{ t('Loading saved ZOLEO devices...') }}</small>
                <small class="text-muted d-block mt-1" *ngIf="!loadingDevices">{{ t('Choose a saved device to auto-fill IMEI and ZOLEO Number, or keep Custom Entry.') }}</small>
                <small class="text-danger d-block mt-1" *ngIf="deviceLoadError">{{deviceLoadError}}</small>
              </div>
            </div>
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-barcode"></i> {{ t('IMEI:') }}</label>
              <div class="col-8">
                <input
                  [formControlName]="'zoleo'"
                  cFormControl
                  placeholder="000000000000000"
                />
                {{ t('Enter Your 15-Digit ZOLEO IMEI') }}
              </div>
            </div>
            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-phone"></i> {{ t('ZOLEO Number:') }}</label>
              <div class="col-8">
                <input
                  [formControlName]="'cell'"
                  cFormControl
                  placeholder="+1234567890"
                />
                {{ t('Enter Your ZOLEO Device Phone Number (Optional). Check-Ins reminders also will be sent to this number.') }}
              </div>
            </div>
            <c-row>
              <c-col xs="6" class="mt-3">
                <button cButton class="px-4 text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i>&nbsp;{{ t('Update Your ZOLEO IMEI') }}
                </button>
              </c-col>
            </c-row>
          </form>
          <hr />
          <div class="form-group row mb-2" >
            <!-- <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-regular fa-circle-user"></i> {{ t('Username:') }}</label>
            <div class="col-8">
              <input
                [(ngModel)]="username"
                cFormControl
                placeholder="username"
              />
              {{ t('Enter Your ZOLEO Username for Authorization') }}
            </div> -->
          </div>
            <div class="form-group row mb-2" >
              <label class="col-6 col-form-label text-start text-sm-end"><i class="fa-solid fa-key"></i> {{ t('Authorize your ZOLEO Device') }}</label>
              <button class="text-white btn btn-info col-4" type="button" (click)="zoleoWindow()" id="integration-btn">
                {{ t('Authorize') }}
              </button>
            </div>
          <hr/>
          <div>
            <h5>{{ t('Learn How to Connect your ZOLEO Device') }}</h5>
            {{ t('To learn how to connect your ZOLEO Device to work with OK Alone please follow the link below.') }}
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/35820781789201-Setting-up-a-ZOLEO-device-with-Ok-Alone" target="_new">https://okalone.zendesk.com/hc/en-gb/articles/35820781789201-Setting-up-a-ZOLEO-device-with-Ok-Alone</a>
          </div>
        </c-col>
        <c-col>
          <img src="assets/images/zoleo-device.png" alt="ZOLEO IMEI Example" class="img-thumbnail img-responsive pull-right"/>
        </c-col>
      </c-row>
    </c-container>
  </ng-container>
</ng-container>
